

import { Shield, Cpu, Zap } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useI18n } from "@/i18n";

const features = [
  {
    icon: Shield,
    title: "Privacy First",
    titleCn: "隐私至上",
    description: "All data stored locally on your Mac. No cloud, no tracking, no compromises.",
    descriptionCn: "所有数据本地存储，无需云端，无追踪，绝对安全。",
  },
  {
    icon: Cpu,
    title: "Apple Silicon Optimized",
    titleCn: "Apple Silicon 优化",
    description: "Built for M4/M5 chips with 32GB+ RAM. Runs directly on-chip for maximum performance.",
    descriptionCn: "专为 M4/M5 芯片 + 32GB 以上内存打造，直接在芯片上运行，性能卓越。",
  },
  {
    icon: Zap,
    title: "Zero Setup",
    titleCn: "即装即用",
    description: "No cloud configuration, no API keys, no hassle. Just install and start using.",
    descriptionCn: "无需云配置，无需 API 密钥，安装即用。",
  },
];

const Features = () => {
  const { language } = useI18n();

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
              {language === 'en' ? 'Built for Privacy & Performance' : '专为隐私与性能打造'}
            </h2>
            <p className="text-xl text-gray-600">
              {language === 'en' ? 'Everything you need to run AI locally on your Mac' : '在 Mac 上本地运行 AI 所需的一切'}
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <Card
                key={index}
                className="border-gray-200 bg-white hover:shadow-lg transition-all duration-300 hover:-translate-y-2"
              >
                <CardContent className="pt-8 pb-8">
                  <div className="mb-6 inline-flex p-4 rounded-2xl bg-blue-100">
                    <feature.icon className="w-8 h-8 text-blue-600" />
                  </div>
                  <h3 className="text-2xl font-semibold mb-2 text-gray-900">
                    {language === 'en' ? feature.title : feature.titleCn}
                  </h3>
                  <p className="text-gray-700">
                    {language === 'en' ? feature.description : feature.descriptionCn}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
